/**
 * Safe fetch utility that checks HTTP status codes and throws errors for non-successful responses
 */

export async function safeFetch(url: string, options: RequestInit): Promise<Response> {
  const response = await fetch(url, options);
  
  if (!response.ok) {
    let errorMessage = `HTTP ${response.status}: ${response.statusText}`;
    
    try {
      const errorData = await response.json();
      if (errorData.error) {
        errorMessage = `HTTP ${response.status}: ${errorData.error}`;
      }
    } catch {
      // If we can't parse JSON, use the default error message
    }
    
    throw new Error(errorMessage);
  }
  
  return response;
}

export async function safeFetchJson<T = any>(url: string, options: RequestInit): Promise<T> {
  const response = await safeFetch(url, options);
  return await response.json();
}

export async function safeFetchBlob(url: string, options: RequestInit): Promise<Blob> {
  const response = await safeFetch(url, options);
  return await response.blob();
}

export async function safeFetchText(url: string, options: RequestInit): Promise<string> {
  const response = await safeFetch(url, options);
  return await response.text();
} 